<template>
  <b-card
    v-if="data"
    class="card-tiny-line-stats text-center"
    body-class="pb-50"
  >
    <b-avatar
      class="mb-1"
      variant="light-success"
      size="45"
    >
      <feather-icon
        size="21"
        icon="FileTextIcon"
      />
    </b-avatar>
    <div class="truncate">
      <h2 class="mb-25 font-weight-bolder">
        {{ (statistiqueProjetsDevis && statistiqueProjetsDevis.contrats) ? statistiqueProjetsDevis.contrats : 0 }}
      </h2>
      <span>CONTRATS</span>
    </div>

    <!--    <h6>CONTRATS</h6>-->
    <!--    <h2 class="font-weight-bolder mb-1">-->
    <!--       {{statistiqueProjetsDevis.contrats ? statistiqueProjetsDevis.contrats : 0 }}-->
    <!--    </h2>-->
    <!--    <vue-apex-charts-->
    <!--      height="70"-->
    <!--      :options="statisticsProfit.chartOptions"-->
    <!--      :series="data.series"-->
    <!--    />-->
  </b-card>
</template>

<script>
import { BCard, BAvatar } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

const $trackBgColor = '#EBEBEB'

export default {
  components: {
    BCard,
    BAvatar,
    VueApexCharts,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    statistiqueProjetsDevis: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data() {
    return {
      statisticsProfit: {
        chartOptions: {
          chart: {

            type: 'line',
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
          },
          grid: {
            borderColor: $trackBgColor,
            strokeDashArray: 5,
            xaxis: {
              lines: {
                show: true,
              },
            },
            yaxis: {
              lines: {
                show: false,
              },
            },
            padding: {
              top: -30,
              bottom: -10,
            },
          },
          stroke: {
            width: 3,
          },
          colors: ['#1abc9c'],
          markers: {
            size: 2,
            colors: '#1abc9c',
            strokeColors: '#1abc9c',
            strokeWidth: 2,
            strokeOpacity: 1,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [
              {
                seriesIndex: 0,
                dataPointIndex: 5,
                fillColor: '#ffffff',
                strokeColor: '#1abc9c',
                size: 5,
              },
            ],
            shape: 'circle',
            radius: 2,
            hover: {
              size: 3,
            },
          },
          xaxis: {
            labels: {
              show: true,
              style: {
                fontSize: '0px',
              },
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
      },
    }
  },
}
</script>
